// extracted by mini-css-extract-plugin
export default {"icon__circle":"WatchIcon_icon__circle__4nk+j"};